












































import { Component, Prop, Vue } from 'vue-property-decorator';

import { DateLabel } from '@/common/datetime';
import { DailyReport } from '@/models/dailyReport.model';
import IndexPageRolloverLabel from '@/pages/index/pages/index/components/IndexPageRolloverLabel.vue';
import { ConfigStore } from '@/store/config';
import { DailyReportStore } from '@/store/dailyReport';

@Component({
  components: {
    DateLabel,
    IndexPageRolloverLabel,
  },
})
export default class IndexPageDailyReportTableRow extends Vue {

  @Prop() isTemperatureShown!: boolean;
  @Prop() overShort!: number;
  @Prop() value!: DailyReport;

  @DailyReportStore.Bind.State isTankFieldsShown!: DailyReportStore.State<'isTankFieldsShown'>;
  @ConfigStore.Bind.State processRolloverDate!: ConfigStore.State<'processRolloverDate'>;

  get isRollover() {
    return this.value.date === this.processRolloverDate;
  }

  get isBeforeRollover() {
    return this.value.date.localeCompare(this.processRolloverDate) < 0;
  }

  goToDetails(item: DailyReport) {
    this.$router.push(`/edit/${item.date}`);
  }

}
